export default "__VITE_ASSET__Bk0uygzU__"